import { useLang } from '@/i18n';
import EcoVideo from 'eco-design/base/eco-video';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { isStatusC } from '../../utils';

interface Props {
    pageType: string;
}

const SectionB2: React.FC<Props> = ({ pageType }) => {
    const { t } = useLang('theProduct.SectionB2');
    const hasInitA = useRef<boolean>(false);
    const enterRefA = useRef<boolean>(false);
    const [enterA, setEnterA] = useState(false);
    const startTimeA = 1.5; //开始变红的时间
    const endTimeA = 4; //结束变红的时间

    const statusC = isStatusC();

    let label = t('label');
    let title = t('title');
    if (pageType === 'normal') {
        label = t('normal_label') || t('label');
        title = t('normal_title') || t('title');
    }
    useEffect(() => {
        const initVideoItem = (videoItem: HTMLVideoElement) => {
            videoItem.addEventListener('timeupdate', () => {
                const durationA = videoItem.duration || 0;
                const currentTime = videoItem.currentTime || 0;
                if (!durationA) {
                    return;
                }
                if (currentTime > startTimeA && currentTime < endTimeA && !enterRefA.current) {
                    //进入变红区
                    enterRefA.current = true;
                    setEnterA(true);
                } else if ((currentTime < startTimeA || currentTime > endTimeA) && enterRefA.current) {
                    //离开变红区
                    enterRefA.current = false;
                    setEnterA(false);
                }
            });
            hasInitA.current = true;
        };
        // 这部分功能用于 SectionB2-tips 这个元素的提示语,在视频某个区域(停电)时显示,有电时隐藏
        const initVideoAll = () => {
            const videoA = document.querySelectorAll('#section-SectionB2 video');
            if (!videoA) {
                return;
            }
            if (!videoA.length) {
                return;
            }
            if (hasInitA.current) {
                return;
            }
            for (let i = 0; i < videoA.length; i++) {
                const videoItem = videoA[i] as HTMLVideoElement;
                initVideoItem(videoItem);
            }
        };
        window.addEventListener('scroll', initVideoAll);
    }, []);
    return (
        <>
            <section id="section-SectionB2" className={`${styles.SectionB2} GtmModuleData-section`} data-section-id="SectionB2" data-section-title={t('title')}>
                <div className="SectionB2-msg">
                    <EcoSectionCommon label={statusC ? '' : label} title={title} desc={t('desc')} />
                </div>
                <div className={`SectionB2-video${enterA ? ' SectionB2-enter' : ' SectionB2-leave'}`}>
                    <EcoVideo
                        autoPlay={true}
                        loop={true}
                        pc="https://websiteoss.ecoflow.com/upload/video/1745414798056/pc3.mp4"
                        h5="https://websiteoss.ecoflow.com/upload/video/1745414810987/pad3.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1745477406407/bb1.jpg"
                        posterH5="https://websiteoss.ecoflow.com/upload/image/1745412627562/h5.jpg"
                    />
                    <div className="SectionB2-tips">{t('text1')}</div>
                </div>
            </section>
        </>
    );
};

export default SectionB2;
